import { objToQueryParams, slugify } from "./strings";
import { removeFalsy } from "./reducers";
import { SearchFilters } from "../interfaces/context/searchContextInterfaces";

export interface DataLayerWindow extends Window {
    dataLayer: any[];
}
declare const window: DataLayerWindow;

/**
 * Are we currently within a browser.
 */
export const isBrowser = () => typeof window !== "undefined" && typeof window.document !== "undefined";

/**
 * Is the browser currently set to 768px or less wide.
 * Expects window.innerWidth;
 */
export const isMobile = () => isBrowser() && window.innerWidth <= 768;

// https://stackoverflow.com/a/8649003
/**
 * Parses a query param string and returns an object of the values
 * @param query - valid string to parse
 */
export const parseQueryParamsToObject = (query: string = "") => {
    let queryString = query;
    if (queryString && queryString[0] === "?") {
        queryString = queryString.substring(1);
    }
    try {
        return JSON.parse(
            `{"${decodeURI(queryString).replace(/"/g, "\\\"").replace(/&/g, "\",\"").replace(/=/g, "\":\"")}"}`
        );
    } catch {
        return null;
    }
};

interface IGenerateUrlPath {
    companyShortName?: string;
    locationName?: string;
    searchKeyword?: string;
    filters?: SearchFilters;
    asPath?: string;
}

/**
 * Returns a new path.
 */
export const generateUrlPath = (params: IGenerateUrlPath) => {
    const {
        companyShortName,
        locationName,
        searchKeyword,
        filters,
        asPath,
    } = params;
    // get categories from filters and then remove categories from filter
    const filterParams = objToQueryParams(removeFalsy(filters));
    const hasParamsOtherThanCategory = otherKeysContainValues(filters, "category");
    let searchInputs = "";

    // order is important for SEO here. location > keyword > company
    searchInputs += locationName ? `location/${slugify(locationName.toLowerCase())}/` : "";
    searchInputs += searchKeyword ? `keyword/${searchKeyword.toLowerCase()}/` : "";
    searchInputs += companyShortName ? `company/${companyShortName.toLowerCase()}/` : "";

    const urlStart = asPath.includes("/hiring") && (!hasParamsOtherThanCategory) ? "/hiring/" : "/search/";
    const result = `${urlStart}${searchInputs}${filterParams}`;
    return result.slice(-1) === "/" ? result : `${result}/`;
};

export const toggleWindowFreeze = () => {
    const {
        body: {
            style
        }
    } = document;

    if (style.overflow === "hidden") {
        style.height = "auto";
        style.overflow = "auto";
    } else {
        style.height = "100vh";
        style.overflow = "hidden";
    }
};

/**
 * Loops through an object to see if any properties other
 * than the checkKey property exists. Search has a depth of 1.
 * @param obj - valid object to loop through
 * @param checkKey - valid string to check
 * @returns boolean
 */
export const otherKeysContainValues = (obj: object, checkKey: string) => {
    let result = false;
    const objectKeys = Object.getOwnPropertyNames(obj);
    objectKeys.forEach((key) => {
        if (key !== checkKey && obj[key].length > 0) {
            result = true;
        }
    });
    return result;
};
